import { useEffect } from 'react';
import { usePreference, usePreferences } from '@/hooks/usePreferences';
import { writeSendAndFileFlag } from '@/services/office/sendAndFileBridge';

/**
 * Recopie la préférence « Envoyer et ranger » dans `OfficeRuntime.storage`, à
 * l'usage du gestionnaire d'événement de rédaction.
 *
 * POURQUOI CETTE RECOPIE EXISTE : le gestionnaire tourne dans un runtime sans
 * authentification possible (cf. `sendAndFileBridge.ts`) et ne peut donc pas
 * demander la préférence au serveur. Le volet, lui, est authentifié ; il sert de
 * courroie.
 *
 * ON N'ÉCRIT QU'APRÈS UNE LECTURE RÉUSSIE (`isSuccess`), et c'est indispensable :
 * `usePreference` rend `false` pendant le chargement comme en cas de panne — un
 * défaut volontaire et sûr pour les actions, mais qui écrirait ici « désactivé »
 * par-dessus un « activé » valide. Un utilisateur ayant activé l'option verrait
 * alors la bannière disparaître au premier back-end en rade, sans rien y comprendre.
 */
export function useSendAndFileFlagMirror(): void {
  const enabled = usePreference('sendAndFile');
  const { isSuccess } = usePreferences();

  useEffect(() => {
    if (!isSuccess) return;
    void writeSendAndFileFlag(enabled);
  }, [enabled, isSuccess]);
}
